/**
 * @generated SignedSource<<9640d8f2e52037b5564d2ff761207084>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type incomingLinkTypes_node$data = {
  readonly __typename: "BitbucketRepository";
  readonly BitbucketRepository_href: AGG$URL | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "CompassComponent";
  readonly CompassComponent_url: string | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ConfluenceBlogPost";
  readonly ConfluenceBlogPost_links: {
    readonly base: string | null;
    readonly webUi: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ConfluenceDatabase";
  readonly ConfluenceDatabase_links: {
    readonly base: string | null;
    readonly webUi: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ConfluenceEmbed";
  readonly ConfluenceEmbed_links: {
    readonly base: string | null;
    readonly webUi: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ConfluenceFolder";
  readonly ConfluenceFolder_links: {
    readonly base: string | null;
    readonly webUi: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ConfluenceFooterComment";
  readonly ConfluenceFooterComment_links: {
    readonly base: string | null;
    readonly webUi: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ConfluenceInlineComment";
  readonly ConfluenceInlineComment_links: {
    readonly base: string | null;
    readonly webUi: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ConfluencePage";
  readonly ConfluencePage_links: {
    readonly base: string | null;
    readonly webUi: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ConfluenceSlide";
  readonly ConfluenceSlide_links: {
    readonly base: string | null;
    readonly webUi: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ConfluenceSpace";
  readonly ConfluenceSpace_links: {
    readonly base: string | null;
    readonly webUi: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ConfluenceWhiteboard";
  readonly ConfluenceWhiteboard_links: {
    readonly base: string | null;
    readonly webUi: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "DeploymentSummary";
  readonly DeploymentSummary_url: string | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "DevOpsDesign";
  readonly DevOpsDesign_url: AGG$URL | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "DevOpsDocument";
  readonly DevOpsDocument_url: AGG$URL | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "DevOpsOperationsIncidentDetails";
  readonly DevOpsOperationsIncidentDetails_url: string | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "DevOpsOperationsPostIncidentReviewDetails";
  readonly DevOpsOperationsPostIncidentReviewDetails_url: string | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "DevOpsProjectDetails";
  readonly DevOpsProjectDetails_url: AGG$URL;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "DevOpsPullRequestDetails";
  readonly DevOpsPullRequestDetails_url: string | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "DevOpsRepository";
  readonly DevOpsRepository_url: AGG$URL | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "DevOpsSecurityVulnerabilityDetails";
  readonly DevOpsSecurityVulnerabilityDetails_url: string | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ExternalBranch";
  readonly ExternalBranch_url: string | null;
  readonly provider: {
    readonly logoUrl: string | null;
    readonly name: string | null;
    readonly providerId: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ExternalBuildInfo";
  readonly ExternalBuildInfo_url: string | null;
  readonly provider: {
    readonly logoUrl: string | null;
    readonly name: string | null;
    readonly providerId: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ExternalCalendarEvent";
  readonly ExternalCalendarEvent_url: string | null;
  readonly provider: {
    readonly logoUrl: string | null;
    readonly name: string | null;
    readonly providerId: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ExternalComment";
  readonly ExternalComment_url: string | null;
  readonly provider: {
    readonly logoUrl: string | null;
    readonly name: string | null;
    readonly providerId: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ExternalCommit";
  readonly ExternalCommit_url: string | null;
  readonly provider: {
    readonly logoUrl: string | null;
    readonly name: string | null;
    readonly providerId: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ExternalConversation";
  readonly ExternalConversation_url: string | null;
  readonly provider: {
    readonly logoUrl: string | null;
    readonly name: string | null;
    readonly providerId: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ExternalDashboard";
  readonly ExternalDashboard_url: string | null;
  readonly provider: {
    readonly logoUrl: string | null;
    readonly name: string | null;
    readonly providerId: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ExternalDataTable";
  readonly ExternalDataTable_url: string | null;
  readonly provider: {
    readonly logoUrl: string | null;
    readonly name: string | null;
    readonly providerId: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ExternalDeal";
  readonly ExternalDeal_url: string | null;
  readonly provider: {
    readonly logoUrl: string | null;
    readonly name: string | null;
    readonly providerId: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ExternalDeployment";
  readonly ExternalDeployment_url: string | null;
  readonly provider: {
    readonly logoUrl: string | null;
    readonly name: string | null;
    readonly providerId: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ExternalDesign";
  readonly ExternalDesign_url: string | null;
  readonly provider: {
    readonly logoUrl: string | null;
    readonly name: string | null;
    readonly providerId: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ExternalDocument";
  readonly ExternalDocument_url: string | null;
  readonly provider: {
    readonly logoUrl: string | null;
    readonly name: string | null;
    readonly providerId: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ExternalMessage";
  readonly ExternalMessage_url: string | null;
  readonly provider: {
    readonly logoUrl: string | null;
    readonly name: string | null;
    readonly providerId: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ExternalPullRequest";
  readonly ExternalPullRequest_url: string | null;
  readonly provider: {
    readonly logoUrl: string | null;
    readonly name: string | null;
    readonly providerId: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ExternalRemoteLink";
  readonly ExternalRemoteLink_url: string | null;
  readonly provider: {
    readonly logoUrl: string | null;
    readonly name: string | null;
    readonly providerId: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ExternalRepository";
  readonly ExternalRepository_url: string | null;
  readonly provider: {
    readonly logoUrl: string | null;
    readonly name: string | null;
    readonly providerId: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ExternalSoftwareService";
  readonly ExternalSoftwareService_url: string | null;
  readonly provider: {
    readonly logoUrl: string | null;
    readonly name: string | null;
    readonly providerId: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ExternalSpace";
  readonly ExternalSpace_url: string | null;
  readonly provider: {
    readonly logoUrl: string | null;
    readonly name: string | null;
    readonly providerId: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ExternalTest";
  readonly ExternalTest_url: string | null;
  readonly provider: {
    readonly logoUrl: string | null;
    readonly name: string | null;
    readonly providerId: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ExternalVideo";
  readonly ExternalVideo_url: string | null;
  readonly provider: {
    readonly logoUrl: string | null;
    readonly name: string | null;
    readonly providerId: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ExternalVulnerability";
  readonly ExternalVulnerability_url: string | null;
  readonly provider: {
    readonly logoUrl: string | null;
    readonly name: string | null;
    readonly providerId: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "ExternalWorkItem";
  readonly ExternalWorkItem_url: string | null;
  readonly provider: {
    readonly logoUrl: string | null;
    readonly name: string | null;
    readonly providerId: string | null;
  } | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "JiraIssue";
  readonly JiraIssue_webUrl: AGG$URL | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "JiraPlatformComment";
  readonly JiraPlatformComment_webUrl: AGG$URL | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "JiraProject";
  readonly JiraProject_webUrl: AGG$URL | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "JiraServiceManagementComment";
  readonly JiraServiceManagementComment_webUrl: AGG$URL | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "LoomComment";
  readonly LoomComment_url: string | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "LoomSpace";
  readonly LoomSpace_url: string;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "LoomVideo";
  readonly LoomVideo_url: string;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "MercuryAsk";
  readonly MercuryAsk_url: AGG$URL | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "MercuryFocusArea";
  readonly MercuryFocusArea_url: string | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "TownsquareComment";
  readonly TownsquareComment_url: string | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "TownsquareGoal";
  readonly TownsquareGoal_url: string | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "TownsquareGoalUpdate";
  readonly TownsquareGoalUpdate_url: string | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "TownsquareProject";
  readonly TownsquareProject_url: string | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  readonly __typename: "TownsquareProjectUpdate";
  readonly TownsquareProjectUpdate_url: string | null;
  readonly " $fragmentType": "incomingLinkTypes_node";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "incomingLinkTypes_node";
};
export type incomingLinkTypes_node$key = {
  readonly " $data"?: incomingLinkTypes_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"incomingLinkTypes_node">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
],
v1 = {
  "concreteType": "ExternalProvider",
  "kind": "LinkedField",
  "name": "provider",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "providerId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "logoUrl"
    }
  ]
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "incomingLinkTypes_node",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ConfluenceBlogPost_links",
          "concreteType": "ConfluenceBlogPostLinks",
          "kind": "LinkedField",
          "name": "links",
          "plural": false,
          "selections": (v0/*: any*/)
        }
      ],
      "type": "ConfluenceBlogPost"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ConfluenceDatabase_links",
          "concreteType": "ConfluenceDatabaseLinks",
          "kind": "LinkedField",
          "name": "links",
          "plural": false,
          "selections": (v0/*: any*/)
        }
      ],
      "type": "ConfluenceDatabase"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ConfluenceEmbed_links",
          "concreteType": "ConfluenceEmbedLinks",
          "kind": "LinkedField",
          "name": "links",
          "plural": false,
          "selections": (v0/*: any*/)
        }
      ],
      "type": "ConfluenceEmbed"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ConfluenceFolder_links",
          "concreteType": "ConfluenceFolderLinks",
          "kind": "LinkedField",
          "name": "links",
          "plural": false,
          "selections": (v0/*: any*/)
        }
      ],
      "type": "ConfluenceFolder"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ConfluenceFooterComment_links",
          "concreteType": "ConfluenceCommentLinks",
          "kind": "LinkedField",
          "name": "links",
          "plural": false,
          "selections": (v0/*: any*/)
        }
      ],
      "type": "ConfluenceFooterComment"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ConfluenceInlineComment_links",
          "concreteType": "ConfluenceCommentLinks",
          "kind": "LinkedField",
          "name": "links",
          "plural": false,
          "selections": (v0/*: any*/)
        }
      ],
      "type": "ConfluenceInlineComment"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ConfluencePage_links",
          "concreteType": "ConfluencePageLinks",
          "kind": "LinkedField",
          "name": "links",
          "plural": false,
          "selections": (v0/*: any*/)
        }
      ],
      "type": "ConfluencePage"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ConfluenceSlide_links",
          "concreteType": "ConfluenceSlideLinks",
          "kind": "LinkedField",
          "name": "links",
          "plural": false,
          "selections": (v0/*: any*/)
        }
      ],
      "type": "ConfluenceSlide"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ConfluenceSpace_links",
          "concreteType": "ConfluenceSpaceLinks",
          "kind": "LinkedField",
          "name": "links",
          "plural": false,
          "selections": (v0/*: any*/)
        }
      ],
      "type": "ConfluenceSpace"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ConfluenceWhiteboard_links",
          "concreteType": "ConfluenceWhiteboardLinks",
          "kind": "LinkedField",
          "name": "links",
          "plural": false,
          "selections": (v0/*: any*/)
        }
      ],
      "type": "ConfluenceWhiteboard"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "JiraIssue_webUrl",
          "kind": "ScalarField",
          "name": "webUrl"
        }
      ],
      "type": "JiraIssue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "JiraPlatformComment_webUrl",
          "kind": "ScalarField",
          "name": "webUrl"
        }
      ],
      "type": "JiraPlatformComment"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "JiraProject_webUrl",
          "kind": "ScalarField",
          "name": "webUrl"
        }
      ],
      "type": "JiraProject"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "JiraServiceManagementComment_webUrl",
          "kind": "ScalarField",
          "name": "webUrl"
        }
      ],
      "type": "JiraServiceManagementComment"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "TownsquareComment_url",
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "TownsquareComment"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "TownsquareGoal_url",
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "TownsquareGoal"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "TownsquareGoalUpdate_url",
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "TownsquareGoalUpdate"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "TownsquareProject_url",
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "TownsquareProject"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "TownsquareProjectUpdate_url",
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "TownsquareProjectUpdate"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "LoomComment_url",
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "LoomComment"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "LoomSpace_url",
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "LoomSpace"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "LoomVideo_url",
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "LoomVideo"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "MercuryAsk_url",
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "MercuryAsk"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "MercuryFocusArea_url",
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "MercuryFocusArea"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "BitbucketRepository_href",
          "kind": "ScalarField",
          "name": "href"
        }
      ],
      "type": "BitbucketRepository"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "DeploymentSummary_url",
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "DeploymentSummary"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "DevOpsDesign_url",
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "DevOpsDesign"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "DevOpsDocument_url",
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "DevOpsDocument"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "DevOpsOperationsIncidentDetails_url",
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "DevOpsOperationsIncidentDetails"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "DevOpsOperationsPostIncidentReviewDetails_url",
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "DevOpsOperationsPostIncidentReviewDetails"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "DevOpsProjectDetails_url",
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "DevOpsProjectDetails"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "DevOpsPullRequestDetails_url",
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "DevOpsPullRequestDetails"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "DevOpsRepository_url",
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "DevOpsRepository"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "DevOpsSecurityVulnerabilityDetails_url",
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "DevOpsSecurityVulnerabilityDetails"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "CompassComponent_url",
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "CompassComponent"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ExternalBranch_url",
          "kind": "ScalarField",
          "name": "url"
        },
        (v1/*: any*/)
      ],
      "type": "ExternalBranch"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ExternalBuildInfo_url",
          "kind": "ScalarField",
          "name": "url"
        },
        (v1/*: any*/)
      ],
      "type": "ExternalBuildInfo"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ExternalCalendarEvent_url",
          "kind": "ScalarField",
          "name": "url"
        },
        (v1/*: any*/)
      ],
      "type": "ExternalCalendarEvent"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ExternalComment_url",
          "kind": "ScalarField",
          "name": "url"
        },
        (v1/*: any*/)
      ],
      "type": "ExternalComment"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ExternalCommit_url",
          "kind": "ScalarField",
          "name": "url"
        },
        (v1/*: any*/)
      ],
      "type": "ExternalCommit"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ExternalConversation_url",
          "kind": "ScalarField",
          "name": "url"
        },
        (v1/*: any*/)
      ],
      "type": "ExternalConversation"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ExternalDashboard_url",
          "kind": "ScalarField",
          "name": "url"
        },
        (v1/*: any*/)
      ],
      "type": "ExternalDashboard"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ExternalDataTable_url",
          "kind": "ScalarField",
          "name": "url"
        },
        (v1/*: any*/)
      ],
      "type": "ExternalDataTable"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ExternalDeal_url",
          "kind": "ScalarField",
          "name": "url"
        },
        (v1/*: any*/)
      ],
      "type": "ExternalDeal"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ExternalDeployment_url",
          "kind": "ScalarField",
          "name": "url"
        },
        (v1/*: any*/)
      ],
      "type": "ExternalDeployment"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ExternalDesign_url",
          "kind": "ScalarField",
          "name": "url"
        },
        (v1/*: any*/)
      ],
      "type": "ExternalDesign"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ExternalDocument_url",
          "kind": "ScalarField",
          "name": "url"
        },
        (v1/*: any*/)
      ],
      "type": "ExternalDocument"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ExternalMessage_url",
          "kind": "ScalarField",
          "name": "url"
        },
        (v1/*: any*/)
      ],
      "type": "ExternalMessage"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ExternalPullRequest_url",
          "kind": "ScalarField",
          "name": "url"
        },
        (v1/*: any*/)
      ],
      "type": "ExternalPullRequest"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ExternalRemoteLink_url",
          "kind": "ScalarField",
          "name": "url"
        },
        (v1/*: any*/)
      ],
      "type": "ExternalRemoteLink"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ExternalRepository_url",
          "kind": "ScalarField",
          "name": "url"
        },
        (v1/*: any*/)
      ],
      "type": "ExternalRepository"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ExternalSoftwareService_url",
          "kind": "ScalarField",
          "name": "url"
        },
        (v1/*: any*/)
      ],
      "type": "ExternalSoftwareService"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ExternalSpace_url",
          "kind": "ScalarField",
          "name": "url"
        },
        (v1/*: any*/)
      ],
      "type": "ExternalSpace"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ExternalTest_url",
          "kind": "ScalarField",
          "name": "url"
        },
        (v1/*: any*/)
      ],
      "type": "ExternalTest"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ExternalVideo_url",
          "kind": "ScalarField",
          "name": "url"
        },
        (v1/*: any*/)
      ],
      "type": "ExternalVideo"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ExternalVulnerability_url",
          "kind": "ScalarField",
          "name": "url"
        },
        (v1/*: any*/)
      ],
      "type": "ExternalVulnerability"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "ExternalWorkItem_url",
          "kind": "ScalarField",
          "name": "url"
        },
        (v1/*: any*/)
      ],
      "type": "ExternalWorkItem"
    }
  ],
  "type": "GraphStoreCypherQueryV2AriNodeUnion",
  "abstractKey": "__isGraphStoreCypherQueryV2AriNodeUnion"
};
})();

(node as any).hash = "20a95b8d7f3de9f851ce516d11ca1937";

export default node;
